import {
  ShopManagementDto,
  ShopManagementDtoSchema,
} from "../../../domain/types/company-shop";
import type { CompanyStatisticsRepository } from "../../../domain/repositories/company/company-statistics-repository";
import { companyShopApiService } from "../../api/company/company-shop-api-service";
import {
  type OrderAmountSummaryQuery,
  type OrderAmountSummaryResponse,
  OrderAmountSummarySchema,
  type RegistrationStatsResponse,
  RegistrationStatsResponseSchema,
  type VisitorStatsResponse,
  VisitorStatsResponseSchema,
  type OrderStatsResponse,
  OrderStatsResponseSchema,
  type PaymentStatsResponse,
  PaymentStatsResponseSchema,
} from "../../../domain/types/company/company-statistics";
import { companyStatisticsUseCase } from "../../../di/container";
import { companyStatisticsApiService } from "../../api/company/company-statistics-api-service";

export class CompanyStatisticsRepositoryImpl
  implements CompanyStatisticsRepository
{
  async getOrderAmountSummary(companyId: number, query: OrderAmountSummaryQuery): Promise<OrderAmountSummaryResponse> {
    const response = await companyStatisticsApiService.getOrderAmountSummary(companyId, query);
    if (!response.data) throw new Error(response.errorMsg || "주문금액 통계를 불러오지 못했습니다.");
    return OrderAmountSummarySchema.parse(response.data);
  }

  async getRegistrationStats(
    companyId: number,
    period: string,
    startDate: string,
    endDate: string,
  ): Promise<RegistrationStatsResponse> {
    const response = await companyStatisticsApiService.getRegistrationStats(
      companyId,
      period,
      startDate,
      endDate,
    );

    if (response.data) {
      return RegistrationStatsResponseSchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "쇼핑몰 홈 가져오기 실패.");
  }

  async getVisitorStats(
    companyId: number,
    period: string,
    startDate: string,
    endDate: string,
  ): Promise<VisitorStatsResponse> {
    const response = await companyStatisticsApiService.getVisitorStats(
      companyId,
      period,
      startDate,
      endDate,
    );

    if (response.data) {
      return await VisitorStatsResponseSchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "방문자 통계 가져오기 실패.");
  }

  async getOrderStats(
    companyId: number,
    period: string,
    startDate: string,
    endDate: string,
  ): Promise<OrderStatsResponse> {
    const response = await companyStatisticsApiService.getOrderStats(
      companyId,
      period,
      startDate,
      endDate,
    );

    if (response.data) {
      return OrderStatsResponseSchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "주문 통계 가져오기 실패.");
  }

  async getPaymentStats(
    companyId: number,
    period: string,
    startDate: string,
    endDate: string,
  ): Promise<PaymentStatsResponse> {
    const response = await companyStatisticsApiService.getPaymentStats(
      companyId,
      period,
      startDate,
      endDate,
    );

    if (response.data) {
      return PaymentStatsResponseSchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "결제 통계 가져오기 실패.");
  }
}

